import { createUseStyles } from 'react-jss';
import { DEKSTOP_FONT_SIZES, DESKTOP_SIZES_BREAKPOINT, MOBILE_FONT_SIZES, } from '@/styles/themes/components/consts';
export const useStyles = createUseStyles((theme) => ({
    wrapper: {
        background: theme.colors.header,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    header: {
        display: 'flex',
        alignItems: 'flex-end',
    },
    headerWithLogo: {
        height: '52px',
    },
    titleWrapper: {
        margin: '15px auto 20px auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '22px',
        position: 'relative',
        padding: '0px 15px',
        [theme.breakpoints.up('md')]: {
            margin: '0px auto 25px auto',
        },
        [theme.breakpoints.up('xl')]: {
            margin: '0px auto 12vh auto',
        },
    },
    phoneIcon: {
        marginRight: '10px',
    },
    title: {
        fontFamily: theme.font.secondary,
        fontWeight: 700,
        fontSize: theme.rem(20),
        color: theme.colors.white,
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
            fontSize: theme.rem(25),
        },
    },
    footer: {
        minHeight: '85px',
        display: 'flex',
        gap: '32px',
        padding: '15px',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    steps: {
        margin: '52px auto 27px auto',
        position: 'relative',
        minHeight: '100px',
        maxWidth: '768px',
        display: 'flex',
        gap: '32px',
        padding: '0px 15px',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            gap: '50px',
        },
    },
    step: {
        display: 'flex',
        gap: '14px',
    },
    nextStepIcon: {
        position: 'absolute',
        bottom: '16px',
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'initial',
        },
    },
    nextSecondStepIcon: {
        left: 'calc(33% - 30px)',
    },
    nextThirdStepIcon: {
        left: 'calc(67% - 43px)',
    },
    stepIcon: {
        flexShrink: 0,
        width: '28px',
        height: '28px',
    },
    stepDescription: {
        color: theme.colors.white,
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    },
    stepHeader: {
        fontWeight: 500,
        fontSize: '14px',
    },
    stepText: {
        fontSize: MOBILE_FONT_SIZES.main,
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            fontSize: DEKSTOP_FONT_SIZES.main,
        },
    },
    help: {
        width: '140px',
        height: '32px',
        borderRadius: '16px',
        border: '1px solid white',
        [theme.breakpoints.up('md')]: {
            position: 'absolute',
            right: '0px',
        },
        [theme.breakpoints.up('xl')]: {
            right: '147px',
        },
    },
}), { name: 'white-label' });
